import BaseModel from '@/orm/models/BaseModel';
import Template from '@/orm/models/Company/Template';

export default class CompanyTemplateSettings extends BaseModel {
  static entity = 'company_template_settings';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      companyId: this.attr(null),
      templateId: this.attr(null),
      data: this.attr(null),
      template: this.belongsTo(Template, 'templateId'),
    };
  }
}
